/**
 * 消息收藏接口封装（走现有 http，accessToken 鉴权）
 */
import http from './httpRequest.js'

/**
 * 收藏一条消息
 * @param {Object} dto { chatType, targetId, messageId }
 */
export const favoriteMessage = (dto) => {
	return http({
		url: '/message/favorite',
		method: 'post',
		data: dto
	})
}

/**
 * 取消收藏
 * @param {Object} dto { chatType, targetId, messageId }
 */
export const unfavoriteMessage = (dto) => {
	return http({
		url: '/message/favorite',
		method: 'delete',
		data: dto
	})
}

/**
 * 查询当前用户的所有收藏列表
 */
export const listFavorites = () => {
	return http({
		url: '/message/favorite/list',
		method: 'get'
	})
}

/**
 * 查询会话内被收藏的消息id列表
 * @param {Number} chatType 1:私聊 2:群聊
 * @param {Number} targetId 私聊为好友id,群聊为群id
 */
export const listFavoriteIds = (chatType, targetId) => {
	return http({
		url: `/message/favorite/ids?chatType=${chatType}&targetId=${targetId}`,
		method: 'get'
	})
}
